import React, { FC, useMemo } from "react";
import { Stack } from "@fluentui/react";
import { Html, stringUtils } from "cayo.ui";

interface TextRunProps {
  lines: string[];
  model: Record<string, any>;
}

const TextRun: FC<TextRunProps> = ({ lines, model }) => {
  const processedLines = useMemo(() => {
    return lines.map((line) => {
      let processedLine = line;
      const matches = line.match(/\{([^}]+)\}/g);

      if (matches) {
        matches.forEach((match) => {
          const key = stringUtils.trim(match.slice(1, -1));
          const value = model[key];
          processedLine = processedLine.replace(match, value !== undefined ? String(value) : match);
        });
      }

      return processedLine;
    });
  }, [lines, model]);

  return (
    <Stack tokens={{ childrenGap: 4 }}>
      {processedLines.map((line, index) => (
        <React.Fragment key={index}>
          <Html value={line} />
        </React.Fragment>
      ))}
    </Stack>
  );
};

export default TextRun;
